import { createAppSlice } from "./app/createAppSlice";
import { PayloadAction } from "@reduxjs/toolkit";

export interface ICounterState {
  count: number;
}

const initialState: ICounterState = {
  count: 0,
};

// If you are not using async thunks you can use the standalone `createSlice`.
export const counterSlice = createAppSlice({
  name: "device",
  initialState,
  reducers: () => ({
    incOrDecCounter: (state, action: PayloadAction<number>) => {
      state.count += action.payload;
    },
  }),
});

export const { incOrDecCounter } = counterSlice.actions;
